import { Injectable, ElementRef, Renderer } from '@angular/core';

import { ApiService, CacheService, LogService, FavoriteService, SeoService, AppContext } from './../shared';
import { Trips } from './../shared/models/trip-models/trips';
import { Port } from './../shared/models';

declare const moment: any;

@Injectable()
export class SchedulesService {
  queryString: string = '';

  public loaderOff = false;
  public noResult = false;
  el: HTMLElement;
  content: HTMLElement;
  container: HTMLElement;

  public downloadLoaderOff = false;

  constructor(private api: ApiService, private cache: CacheService, private logger: LogService,
    private favorite: FavoriteService, private seo: SeoService, public app: AppContext, el: ElementRef, private renderer: Renderer) {
  }

  getSchedules(params: any): Promise<Trips> {
    this.loaderOff = false;
    this.noResult = false;
    this.logger.log('schedules.service', 'getSchedules', params);
    // let cache = this.cache.get('ports' + this.queryString);
    let promise = this.api.getApiClient().then(client => this.callGetSchedules(client, params));
    // let server = Observable.fromPromise(promise);

    // this.schedules = Observable.concat(cache, server);
    // this.schedules = server;
    // this.cache.updateCache('ports' + this.queryString, this.schedules);

    return promise;
  }

  getPerformanceSchedules(params: any): Promise<Trips> {
    return this.api.getApiClient().then(client => this.callGetSchedules(client, params));
  }

  callGetSchedules(apigClient: any, query: any): Promise<Trips> {
    this.logger.log('schedules.service', 'callGetPortSchedules', query);

    let params = {};
    let additionalParams = {
      headers: { 'Content-Type': 'application/json' },
      queryParams: query
    };

    return apigClient.tripsGet(params, '', additionalParams)
      .then(this.handleSchedulesResolve.bind(this)).catch(this.handleSchedulesError.bind(this));
  }

  handleSchedulesResolve(result: any): Trips {
    this.logger.log('schedules.service', 'result', result);
    if (!this.formatUI(result)) {
      return null;
    }

    let trips = new Trips(result);
    this.seo.setTrips(trips);

    return trips;
  }

  handleSchedulesError(error: any): number {
    this.resizeSidebar();
    this.loaderOff = true;
    this.noResult = true;

    throw(this.api.handleError(error));
  }

  formatUI(result): boolean {
    if (result.data === null) {
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      return false;
    } else if (result.data.hasOwnProperty('errorMessage')) {
      let response = JSON.parse(result.data.errorMessage);
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      this.api.handleError(response);
      return false;
    } else if (result.data.items === undefined || result.data.items.length === 0 || result.data.summary.count === 0) {
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      return false;
    } else {
      this.resizeSidebar();
      this.loaderOff = true;
      return true;
    }
  }

  getParametersFromSearchId(searchId: string) {
    return this.api.generateApiClient().then(client => this.callGetParameters(client, searchId));
  }

  callGetParameters(apigClient: any, searchId: string) {
    return new Promise((resolve, reject) => {
      let params = {
        searchId: searchId
      };
      let body = {
        searchId: searchId
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };
      try {
        apigClient.searchesSearchIdGet(params, body, additionalParams)
          .then((result) => {
            this.logger.log('schedule.service', 'callGetParameters result', result);
            resolve(result);
          }).catch((err) => {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        this.resizeSidebar();
        this.loaderOff = true;
        this.noResult = true;
        reject(null);
      }
    });
  }

  resizeSidebar() {
    setTimeout(() => {
      try {
        this.el = document.getElementById('refine-sidebar-inner');
        this.content = document.getElementById('results-content');
        this.container = document.getElementById('content-sidebar-wrapper');

        this.renderer.setElementProperty(this.container, 'style', false);

        if (this.el.scrollHeight > this.content.scrollHeight) {
          let heightNum = (this.el.scrollHeight + 200);

          this.renderer.setElementStyle(this.container, 'height', heightNum + 'px');
        } else {
          this.logger.log('schedules.service', 'resizeSidebar', 'NOT SETTING HEIGHTS');
        }
      } catch (ex) {
      }
    }, 10);
  }

  getPortsForLocation(type: string, id: string) {
    let params = {
      limit: 200
    };

    let idParam = type === 'country' ? 'country_id' : 'region_id';
    params[idParam] = id;

    let local = localStorage.getItem(JSON.stringify(params));

    // if (local === undefined || local === null) {
    return this.api.getApiClient().then(client => this.callGetPortsForLocation(client, params));
    // } else {
    //  return this.getPortsForLocationFromStorage(local);
    // }
  }

  private getPortsForLocationFromStorage(local: string): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      try {
        let formatted = JSON.parse(local);
        resolve(formatted);
      } catch (ex) {
        this.logger.log('schedules.service', 'getPortsForLocationFromStorage catch', ex);
        resolve(null);
      }
    });
  }

  private callGetPortsForLocation(apigClient: any, query: any): Promise<Array<any>> {
    this.logger.log('schedules.service', 'callGetPortsForLocation', query);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: query
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('schedules.service', 'callGetPortsForLocation resolve', result);
            if (result.data === null || result.data.items.length === 0) {
              resolve([]);
            } else {
              let formatted = [];
              for (let current = 0; current < result.data.items.length; current++) {
                let port = new Port(result.data.items[current]);
                formatted.push({
                  count: 0,
                  iconUrl: '../img/port-selected.png',
                  selected: true,
                  port: port
                });
              }

              formatted.sort((a, b) => {
                let one = a.port.name.toUpperCase();
                let two = b.port.name.toUpperCase();
                return (one < two) ? -1 : (one > two) ? 1 : 0;
              });

              localStorage.setItem(JSON.stringify(query), JSON.stringify(formatted));
              resolve(formatted);
            }
          }).catch((err) => {
            this.loaderOff = true;
            this.noResult = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        this.logger.log('schedules.service', 'catch', ex);
        reject(null);
      }
    });
  }

  getDownload(searchId: string) {
    // return 'https://v2gcar23gi.execute-api.us-east-1.amazonaws.com/beta/searches/' + searchId + '/download';
    this.downloadLoaderOff = true;
    this.api.getApiClient().then(client => this.callGetDownload(client, searchId)).then(() => {
    });
  }

  private callGetDownload(apigClient: any, searchId: string) {
    this.logger.log('schedules.service', 'callGetDownload', searchId);
    new Promise((resolve, reject) => {
      let params = {
        searchId: searchId
      };
      let body = {
        searchId: searchId
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };
      try {
        apigClient.searchesSearchIdDownloadGet(params, body, additionalParams)
          .then((result) => {
            this.logger.log('schedules.service', 'callGetDownload result', result);
            this.transformDownload(result.data);
            resolve(null);
          }).catch((err) => {
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        this.logger.log('schedules.service', 'callGetDownload catch', ex);
      }
    });
  }

  transformDownload(data: string) {
    let sliceSize = 512;

    let byteCharacters = atob(data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);

      for (let index = 0; index < slice.length; index++) {
        byteNumbers[index] = slice.charCodeAt(index);
      }

      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: 'text/csv' });
    let blobUrl = URL.createObjectURL(blob);

    if (window.navigator.msSaveBlob !== undefined) {
      window.navigator.msSaveBlob(blob, 'test.csv');
      this.downloadLoaderOff = false;
    } else {
      this.saveDownload(blobUrl, 'LinescapeDownload' + moment().format('YYYYMMDDHHmmss') + '.csv');
    }
  }

  saveDownload(url: string, fileName: string) {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style.setProperty('display', 'none');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    this.downloadLoaderOff = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/schedules/schedules.service.ts